import { useQuery } from 'react-query'
import { getUsers } from 'utils/requests'
// helpers
import get from 'lodash/get'
import { useEffect } from 'react'
import { message } from 'antd'

const useFetchData = (states, actions) => {
  const handlerRequest = useQuery<any>({
    queryKey: 'users-data',
    queryFn: () =>
      getUsers({ is_fraudulent: true, limit: 9, page: states.page, search: states.searchInput }),
    initialData: [],
    select: rawData => {
      const data = get(rawData, 'data', [])
      const paginationInfo = get(rawData, 'paginationInfo', undefined)

      return {
        paginationInfo,
        data: data.map(({ identity_uuid, ...user }) => ({
          identity_uuid,
          ...user,
          key: identity_uuid
        }))
      }
    },
    onSuccess: () => {
      actions.setDirtyBit(false)
    },
    onError: () => {
      actions.setDirtyBit(false)
      message.error({
        type: 'error',
        content: 'Algo ha salido mal'
      })
    }
  })

  useEffect(() => {
    states.dirtyBit && handlerRequest.refetch()
  }, [states.dirtyBit])

  useEffect(() => {
    return () => handlerRequest.remove()
  }, [])

  return handlerRequest
}

export default useFetchData
